<template>
  <div class="home">
    <header class="hero">
      <div style="margin-bottom: 40vh;">
        <h1></h1>
        <p style="font-size: 48px; font-family: 'Comic Sans MS', sans-serif;">❤️养好啵啵鼻，养成更好的自己❤️</p>
        <p style="font-size: 24px; font-family: 'Comic Sans MS', sans-serif;">🪺治愈萌宠奇旅App［养只啵啵鼻］</p>
        <p style="font-size: 24px; font-family: 'Comic Sans MS', sans-serif;">🫶让爱自己成为习惯，让快乐成为标准</p>
        <p style="font-size: 24px; font-family: 'Comic Sans MS', sans-serif;">⭐️专属于你的啵啵鼻等待领养中～</p>
      </div>
        治愈萌宠奇旅App［养只啵啵鼻］🫶让自爱成为习惯，让快乐成为标准⭐️专属于你的啵啵鼻等待领养中～
      <div class="hero-image"></div>
    </header>

    <section class="services">
      
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.service-card {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}
</style> 